import classNames from 'classnames'
import { useEffect } from 'react'
import { useApp } from '../../../hooks/useApp'
import { AddToCartButton } from '../AddToCartButton/AddToCartButton'

interface Props {
  className?: string
}

export const BauCtas = ({ className }: Props) => {
  const { mainProduct } = useApp()
  const {
    enableBauCtas,
    hasSizeGuide,
    sizeGuideDrawerId,
    findStoreUrl,
    firstAvailableVariantId,
    hasOnlyDefaultVariant,
    shopPermanentDomain
  } = mainProduct.globalSettings

  const isAvailable = mainProduct.variants.some((variant) => variant.available)
  const showFindInStore = Boolean(
    enableBauCtas && isAvailable && findStoreUrl && firstAvailableVariantId && shopPermanentDomain
  )

  useEffect(() => {
    if (!showFindInStore || !findStoreUrl) {
      return
    }

    document
      .querySelectorAll('script[data-builder-find-in-store-script="true"]')
      .forEach((node) => node.remove())

    const findInStoreContainer = document.getElementById('brauz-find-in-store-product-page')

    if (findInStoreContainer) {
      findInStoreContainer.innerHTML = ''
    }

    const script = document.createElement('script')
    script.src = findStoreUrl
    script.async = true
    script.dataset.builderFindInStoreScript = 'true'

    document.body.appendChild(script)

    return () => {
      script.remove()
    }
  }, [findStoreUrl, showFindInStore])

  return (
    <div className={classNames('builder-bau-ctas flex flex-col gap-2 ProductForm__BuyButtons', className)}>
      <AddToCartButton />

      {showFindInStore && (
        <>
          <div
            id="brauz-find-in-store-config-product-page"
            data-sd={shopPermanentDomain}
            data-cvi={String(firstAvailableVariantId)}
            data-hodv={String(hasOnlyDefaultVariant)}
            style={{ display: 'none', width: 0 }}
          ></div>
          <div id="brauz-find-in-store-product-page" className="builder-bau-ctas__find-in-store"></div>
        </>
      )}

      {enableBauCtas && hasSizeGuide && sizeGuideDrawerId && (
        <div className="additional-drawer--button pt-2">
          <div
            className="additional-drawer__size-guide Button Button--quaternary-dark"
            data-action="toggle-drawer"
            data-drawer-id={`${sizeGuideDrawerId}-drawer`}
            aria-label="Size Guide"
          >
            <span>Size Guide</span>
          </div>
        </div>
      )}
    </div>
  )
}
